export class ContextVariable {
    name:string;
    value:string;
}